import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const StyledText = styled.text`
  color: ${beam.font.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
`;

export const User = styled.div`
  display: flex;
  align-items: center;
`;

export const Line = styled.div`
  height: 0;
  width: 100%;
  margin-top: 9px;

  /* borders/default-border */
  border: 1px solid #e9edf1;
`;
